import React from 'react';
import { FiSettings } from 'react-icons/fi';

/**
 * SettingsGearIcon
 * Ikona ozubeného kolieska pre sekcie konfigurácie a nastavení.
 */
const SettingsGearIcon = ({ className = 'inline-block align-middle', ...props }) => (
  <FiSettings className={className} {...props} />
);

export default SettingsGearIcon;

